import { api } from '../axios'

const ZohoCredentialsService = (() => {
  const fetchAllCredentials = async () => {
    const res = await api.get(`/zoho-credential`)
    return res.data
  }
  const createCredential = async data => {
    const res = await api.post(`/zoho-credential`, data)
    return res.data
  }
  const restoreCredential = async id => {
    const res = await api.patch(`/zoho-credential/${id}/restore`)
    return res.data
  }
  const deleteCredential = async id => {
    const res = await api.delete(`/zoho-credential/${id}`)
    return res.data
  }

  return {
    fetchAllCredentials,
    createCredential,
    restoreCredential,
    deleteCredential
  }
})()

export default ZohoCredentialsService
